<script lang="ts">
    class IncentiviBuoniMobilita {
        incentiviScontiTrasportoPub: boolean;
        incentiviScontiTrasportoPubNote: string;
        incentiviScontiMobilitaCondivisa: boolean;
        incentiviScontiMobilitaCondivisaNote: string;
        incentiviUsoBike: boolean;
        incentiviUsoBikeNote: string;
        incentiviScontiCarPooling: boolean;
        incentiviScontiCarPoolingNote: string;

        constructor(init?: IncentiviBuoniMobilita) {
            Object.assign(this, init);
        }
    }

    export let data: IncentiviBuoniMobilita = new IncentiviBuoniMobilita();

    const properties = [
        { name: "Incentivi/sconti per il trasporto pubblico", key: "incentiviScontiTrasportoPub", noteKey: "incentiviScontiTrasportoPubNote" },
        { name: "Incentivi/sconti per servizi di mobilità condivisa", key: "incentiviScontiMobilitaCondivisa", noteKey: "incentiviScontiMobilitaCondivisaNote" },
        { name: "Incentivi all’uso della bicicletta (bike to work)", key: "incentiviUsoBike", noteKey: "incentiviUsoBikeNote" },
        { name: "Incentivi/sconti per chi fa car pooling", key: "incentiviScontiCarPooling", noteKey: "incentiviScontiCarPoolingNote" },
    ];

    function isAnyFieldSet(): boolean {
        return properties.some((property) => data?.[property?.key] !== undefined);
    }
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
            <th class="border border-black">Note</th>
        </tr>
    </thead>
    <tbody>
        {#each properties as property}
            <tr>
                <td class="text-center border border-black">{property?.name}</td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                    {data?.[property?.key] !== undefined ? (data?.[property?.key] ? 'Sì' : 'No') : '-'}
                </td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                    {data?.[property?.key] && data?.[property?.noteKey] ? data?.[property?.noteKey] : '-'}
                </td>
            </tr>
        {/each}
    </tbody>
</table>